import React, { useRef } from "../../__compat__/react/main.entry.mjs.mjs";
import { Text } from "../Text/index.mjs.mjs";
import { useSpacing } from "../../api/spacing/useSpacing.mjs.mjs";
import { pickDataProps } from "../../interfaces/commonProps.mjs.mjs";
import { StyledTable, TableCaption, TableWrapper } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
let captionId = 0;
const getCaptionId = () => {
    return `Cap-${captionId++}`;
};
export const Table = React.forwardRef(({ caption, children, fixedLayout, displayMode = 'auto', id: passedId, ...restProps }, ref) => {
    const { current: internalId } = useRef(getCaptionId());
    return (React.createElement(TableWrapper, { outerSpacing: useSpacing(restProps), role: "region", tabIndex: 0, id: passedId, ref: ref, displayMode: displayMode, ...pickDataProps(restProps) },
        React.createElement(StyledTable, { "aria-labelledby": caption ? internalId : undefined, role: "table", fixedLayout: fixedLayout, displayMode: displayMode },
            caption && (React.createElement(TableCaption, { displayMode: displayMode },
                React.createElement(Text, { as: "span", variant: "order3", id: internalId }, caption))),
            React.createElement(TableContext.Provider, { value: { displayMode } }, children))));
});
Table.displayName = 'Table';
//# sourceMappingURL=Table.mjs.mjs.map